import { useEffect, useState } from 'react';
import { paymentApi } from '@/api';
import { getCurrencySymbol } from 'Utils/utils';
import { store } from 'Store/store.index';

/**
 * @returns
 *    {
 *       "code": "xxx",
 *       "name": "xxx",
 *       "is_eu": 1 或者 0
 *   }
 */
export const useUserCountry = () => {
  const [country, setCountry] = useState({});
  useEffect(() => {
    const fetchCountry = async () => {
      const res = await paymentApi.getCountry(store.userStore.token);
      if (res.ret === 200 && res.message.toLowerCase() === 'success') {
        const defaultCountryCode = res.data.default.country;
        const curCountry = res.data.list[defaultCountryCode];
        setCountry(curCountry);
      }
    };
    fetchCountry();
  }, []);
  return country;
};

/**
 * @returns
 *   {
 *       "currency_code": "xxx",
 *       "name": "xxx",
 *       "currency_name": "xxx",
 *       "currency_symbol": "xxx"
 *   }
 */
export const useUserCurrency = () => {
  const [currency, setCurrency] = useState({});
  const [currencyList, setCurrencyList] = useState([]);
  useEffect(() => {
    const fetchCurrency = async () => {
      const { userEmail } = store.userStore.userInfo;
      const res = await paymentApi.getCurrency(store.userStore.token, userEmail);
      if (res.ret === 200 && res.message.toLowerCase() === 'success') {
        const defaultCurrencyCode = res.data.default.code;
        const curCurrency = res.data.list[defaultCurrencyCode];
        curCurrency.currency_symbol = getCurrencySymbol(curCurrency.currency_code, curCurrency.currency_symbol);
        setCurrency(curCurrency);

        const updateList = Object.values(res.data.list);
        updateList.forEach(i => {
          i.value = i.currency_code;
          i.label = i.currency_name;
          i.currency_symbol = getCurrencySymbol(i.currency_code, i.currency_symbol);
        });
        setCurrencyList(updateList);
      }
    };

    fetchCurrency();
  }, []);
  return { currency, currencyList };
};